<template>
<div>
    <div
        class="d-md-block d-none"
        v-if="isShow && isExistence"
        :class="ls_style ? `ls_style_${ls_style}` : 'ls_style_1'"
    >
        <a
            @click="goProduct"
            class="lastsales_a page_text_font"
            :class="mb_position == 'bottom' ? 'app-bottom' : 'app-top'"
        >
            <div class="lastsales page_text_font" :class="{'add-bottom':isAction}">
                <div class=" lastsales-close-div">
                    <i
                        class="iconfont icon-cm-guanbiicon lastsales-close"
                        @click="close_lastsales"
                    ></i>
                </div>
                <v-lazy-img v-if="lastSale.productImage" class="lastsales-img"  :alt="lastSale.productName" :data-url="lastSale.productImage.url"   :src="lastSale.productImage.thumbnail"></v-lazy-img>
                <v-lazy-img v-else class="lastsales-img" ></v-lazy-img>
                <!-- <span class="iconfont icon-cm-yanjing"></span> -->
                <span class="lastsales-product-name">
                    <span> {{ lastSale.productName }} </span> 
                </span>
                <span class="lastsales-customer-name">
                    {{ lastSale.customerName  }}
                </span>
                <span class="lastsales-purchased">
                    <span>
                    <i  v-if="ls_style == '2' || ls_style == '3'"  class="iconfont  icon-cm-yigou lastsales-purchased-icon" ></i>
                    {{ $t("lastsales.recently_purchased") }}</span> 
                    <span v-if="ls_style == '3'" class="lastsales-purchased__time">{{lastSale.orderDate}}</span>
                </span>
            </div>
        </a>
        <div
            class="app-lastsales page_text_font"
            :class="[
                mb_position == 'bottom' ? 'app-bottom' : '',
                ls_style ? `app-lastsales__${ls_style}` : 'app-lastsales__1'
            ]"
        >
            <a @click="goProduct">
                <span
                    class="app-lastsales-img iconfont icon-cm-gouwucheman"
                ></span>
                <span class="app-lastsales-customer-name" >
                    {{ lastSale.customerName }}
                    {{ $t("lastsales.recently_purchased") }}
                </span >
            </a>
        </div>
    </div>
    <div
        class="d-block d-md-none"
        v-if="isMbOpen && isShow && isExistence"
        :class="[
            mbStyle ? `ls_style_${mbStyle}` : 'ls_style_1',
            {
            'app-mb-stick-top': headerWrapHeight <= 0, //移动端页头不吸顶时 样式一 变成圆角 占满屏幕 置顶
            },
        ]"
    >
        <a
            @click="goProduct"
            class="lastsales_a page_text_font"
            :class="mbPosition == 'bottom' ? 'app-bottom' : 'app-top'"
        >
            <div class="lastsales page_text_font" :class="{'add-bottom':isAction}">
                <div class=" lastsales-close-div">
                    <i
                        class="iconfont icon-cm-guanbiicon lastsales-close"
                        @click="close_lastsales"
                    ></i>
                </div>
                <v-lazy-img v-if="lastSale.productImage" class="lastsales-img"  :alt="lastSale.productName" :data-url="lastSale.productImage.url"   :src="lastSale.productImage.thumbnail"></v-lazy-img>
                <v-lazy-img v-else class="lastsales-img" ></v-lazy-img>
                <!-- <span class="iconfont icon-cm-yanjing"></span> -->
                <span class="lastsales-product-name">
                    <span>{{ lastSale.productName }}</span>
                </span >
                <span class="lastsales-customer-name">
                  {{ lastSale.customerName  }}
                </span>
                <span class="lastsales-purchased">
                    <span><i
                        v-if="mbStyle == '2' || mbStyle == '3'"
                        class="iconfont  icon-cm-yigou lastsales-purchased-icon"
                    ></i>
                    {{ $t("lastsales.recently_purchased") }}</span> 
                    <span v-if="mbStyle == '3'" class="lastsales-purchased__time">{{lastSale.orderDate}}</span>
                </span>
            </div>
        </a>
        <div
            class="app-lastsales page_text_font"
            :class="[
                mbPosition == 'bottom' ? 'app-bottom' : '',
                mbStyle ? `app-lastsales__${mbStyle}` : 'app-lastsales__1'
            ]"
        >
            <a @click="goProduct">
                <span
                    class="app-lastsales-img iconfont icon-cm-gouwucheman"
                ></span>
                <span class="app-lastsales-customer-name" >
                  {{ lastSale.customerName }}
                    {{ $t("lastsales.recently_purchased") }}
                </span >
            </a>
        </div>
    </div>


</div>
</template>
<script>
import throttle from "lodash/throttle"

export default {
    props: ["route", "is_all", "show_page", "mb_position", "ls_style","phone_settings"],
    data() {
        return {
            lastSale: {
                productImage: {
                    ID: "",
                    url: "",
                    thumbnail: "",
                },
                productName: "",
                customerName: "",
                productUrl: ""
            },
            lastSales: [],
            nowLength: 0, //当前播放的购买记录
            changeSale: "",
            isShow: false,
            isExistence: true,
            isAction: false,
            isMbOpen:true, //移动端是否开启
            mbStyle:1, //移动端样式 
            mbPosition:'top', //移动端弹出位置
            headerWrapHeight:0,//页头的高度 随着吸顶与否改变
        };
    },

    mounted() {
        const showPage = JSON.parse(this.show_page);
        const phone_settings = JSON.parse(this.phone_settings);
        this.isMbOpen= phone_settings.open_close.toString() ? phone_settings.open_close : true; //移动端是否开启
        this.mbStyle=phone_settings.phone_style || this.ls_style || 1; //移动端样式 
        this.mbPosition=phone_settings.type || this.mb_position || 'top';
    
        if (this.is_all === "1") {
            this.fetchLastSales();
        } else if (this.is_all === "0") {
            if (showPage && showPage.length) {
                showPage?.some(subItem => {
                    switch (subItem) {
                        case 1:
                            if (this.route == "commoditylist") {
                                this.fetchLastSales();
                                return true;
                            }
                            break;
                        case 2:
                            if (this.route == "product-index") {
                                this.fetchLastSales();
                                return true;
                            }
                            break;
                        case 3:
                            if (this.route == "collection-index") {
                                this.fetchLastSales();
                                return true;
                            }
                            break;
                        case 4:
                            if (this.route == "collection-show") {
                                this.fetchLastSales();
                                return true;
                            }
                            break;
                        case 5:
                            if (this.route == "cart") {
                                this.fetchLastSales();
                                return true;
                            }
                            break;
                        case 6:
                            if (this.route == "search") {
                                this.fetchLastSales();
                                return true;
                            }
                            break;

                        default:
                            break;
                    }
                });
            }
        }
        document.addEventListener("scroll", throttle(this.handleScroll,300), true);
        setTimeout(this.handleScroll, 10);
    },

    methods: {
        async fetchLastSales() {
            try {
                let res = await this.$axios.get(API.last_sales);
                this.lastSales = res.data.data;
                if (!this.lastSales.length) {
                    this.isExistence = false
                    return;
                }
                this.lastSale = this.lastSales[this.nowLength];
                this.isShow = true;
                this.changeSale = setInterval(() => {
                    this.isShow = false;
                    this.lastSale = this.lastSales[++this.nowLength];
                    this.isShow = true;
                    if (!this.lastSale) {
                        this.isShow = false;
                        this.isExistence = false;
                        clearInterval(this.changeSale);
                    }
                }, 10000);
            } catch (error) {
                return;
            }
        },
        close_lastsales(e) {
            e.stopPropagation();
            // this.isShow = false;
            this.isExistence = false;
        },
        goProduct() {
            window.open(this.lastSale.productUrl, "_self");
        },
        handleScroll() {
            let quickPurchased = this.$('.quickPurchased');
            if (quickPurchased.length > 0 && quickPurchased.css('display')=='block') {
                this.isAction = true;
            } else {
                this.isAction = false;
            }
            let header = this.$('[custom_class=headerAllThemeBtnClass]');
            let headerTitle = this.$('[custom_class=headerTitleAllThemeBtnClass]')
            this.headerWrapHeight = 0;
            if(header.length){
                let headerTitle = header.children('.indexwrapheadtitle');
                this.headerWrapHeight += headerTitle[0]?.getBoundingClientRect()?.bottom < 0 || header.css('opacity')=='0' ? 0: headerTitle.outerHeight();
            }
            if(headerTitle.length){
                this.headerWrapHeight += headerTitle[0]?.getBoundingClientRect()?.bottom < 0 || headerTitle.css('opacity')=='0'? 0:headerTitle.outerHeight();
            }
            console.log(this.headerWrapHeight,'headerWrapHeight');
            if(this.headerWrapHeight > 0){
                // 小于等于0时 走.ls_style_1.app-mb-stick-top .app-lastsales__1样式
                this.$el.style.setProperty('--headerHeight',  `${this.headerWrapHeight +10 }px`)
            }
        }
    }
};
</script>
<style scoped lang="scss">
.ls_style_1 {
    a:hover {
        text-decoration: none;
        color: #111111;
        opacity: 1;
    }

    .lastsales {
        line-height: 1.6;
        width: 240px;
        height: 90px;
        font-size: 13px !important;
        background-color: rgba(0, 0, 0, 0.7);
        border-radius: 6px;
        position: fixed;
        bottom: 16px;
        animation: showHideContainerStyle1 10s;
        animation-iteration-count: infinite;
        z-index: 1000;
        // pointer-events: none; //元素不会成为鼠标事件的target，不遮挡下层元素
        text-align: left;
        .lastsales-close {
            display: none;
        }
        .lastsales-img {
            height: 88px;
            width: 88px;
            border-radius: 6px 0 0 6px;
            margin: 1px 10px 1px 1px;
            float: left;
            animation: showHideContent 10s;
            animation-iteration-count: infinite;
        }
        .lastsales-product-name {
            color: white;
            width: 130px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            position: absolute;
            top: 5px;
            animation: showHideContent 10s;
            animation-iteration-count: infinite;
        }
        .lastsales-customer-name {
            color: white;
            width: 130px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            position: absolute;
            bottom: 25px;
            animation: showHideContent 10s;
            animation-iteration-count: infinite;
        }
        .lastsales-purchased {
            color: white;
            position: absolute;
            width: 130px;
            bottom: 5px;
            animation: showHideContent 10s;
            animation-iteration-count: infinite;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .app-lastsales__1 {
        line-height: 1.6;
        width: 240px;
        height: 30px;
        font-size: 13px;
        background-color: rgba(0, 0, 0, 0.7);
        border-radius: 6px;
        position: fixed;
        top: 80px;
        left: 20px;
        animation: showHideContainerAppStyle1 10s;
        animation-iteration-count: infinite;
        // 在购物车抽屉之下(205)
        z-index: 204;
        pointer-events: none; //元素不会成为鼠标事件的target，不遮挡下层元素
        text-align: left;
        .lastsales-close {
            display: none;
        }
        .app-lastsales-img {
            margin-right: 10px;
            margin-left: 10px;
            color: orange;
            animation: showHideContentApp 10s;
            animation-iteration-count: infinite;
            font-size: 20px;
        }

        .app-lastsales-customer-name {
            color: white;
            width: 190px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            position: absolute;
            top: 5px;
            font-size: 12px;
            animation: showHideContentApp 10s;
            animation-iteration-count: infinite;
        }

        // .app-top {
        //     top: 12px;
        //     bottom: unset;
        // }
    }

    .app-bottom {
        top: unset;
        bottom: 100px;
    }
}
.ls_style_2,.ls_style_3 {
    // .lastsales-close {
    //     display: none;
    // }
    a:hover {
        text-decoration: none;
        color: #111111;
        opacity: 1;
    }
    .lastsales {
        line-height: 1.6;
        height: 84px;
        font-size: 13px !important;
        background-color: #ffffff;
        border-radius: 6px;
        z-index: 1000;
        text-align: left;
        padding: 12px;
        .lastsales-close-div {
            position: relative;
            .lastsales-close {
                position: absolute;
                z-index: 1001;
            }
        }

        .lastsales-img {
            height: 60px;
            width: 60px;
            border-radius: 6px;
            margin: 1px 10px 1px 1px;
            float: left;
        }
        .lastsales-product-name {
            color: #3e4041;
            width: 215px;
            // position: absolute;  //会导致多行省略无效
            span {
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
        .lastsales-customer-name {
            display: none;
        }
        .lastsales-purchased {
            color: #3e4041;
            position: absolute;
            width: 209px;
            bottom: 12px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}

.ls_style_3 {
    .lastsales {
        font-size: 12px !important;
    }
    .lastsales-product-name {
        span {
            &::before {
            content: "\e613";
            font-family: iconfont !important;
            font-style: normal;
            margin-right: 5px;
            }
        }
    }
    .lastsales-purchased {
        display: inline-flex;
        justify-content: space-between;
    }
}

.add-bottom {
    bottom: 116px !important;
}

.app-lastsales__2,.app-lastsales__3 {
    display: none;
}

.lastsales_a {
    z-index: 1000;
    position: fixed;
    cursor: pointer;
}
.lastsales-img {
    object-fit: contain;
}
@media screen and (max-width: 575px) {
    .ls_style_1 {
        .lastsales {
            display: none;
        }
        .app-lastsales__1 {
            display: visible;
            top: calc(var(--headerHeight,'80px'))
        }
    }
    .ls_style_1.app-mb-stick-top .app-lastsales__1{
        // 移动端样式一 且吸顶时候样式
        top: 0;
        left: 0;
        width: 100%;
        border-radius: 0;
        text-align: center;
        .app-lastsales-customer-name{
            position: unset;
            vertical-align: text-bottom;
        }
    }
    .ls_style_2,.ls_style_3 {
        .lastsales_a {
            position: fixed;
            // top: 12px;
            width: 100vw;
            // background: #ccc;
            padding: 0 12px;
            z-index: 1015;
        }
        .lastsales {
            width: 100%;
            animation: showHideContainerAppStyle2 10s;
            animation-iteration-count: infinite;
            .lastsales-close-div {
                .lastsales-close {
                    top: -8px;
                    right: 4px;
                    // display: flex;
                    margin: 30px;
                    top: -47px;
                    right: -47px;
                    font-size: 52px;
                    box-shadow: 0px 1px 10px #dde0e3;
                    width: 20px;
                    height: 20px;
                    background: #fff;
                    border-radius: 50vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    animation: showHideContentApp 10s;
                    animation-iteration-count: infinite;
                }
            }

            .lastsales-img {
                animation: showHideContentApp 10s;
                animation-iteration-count: infinite;
            }
            .lastsales-product-name {
                width: calc(100vw - 130px);
                animation: showHideContentApp 10s;
                animation-iteration-count: infinite;
            }
            .lastsales-customer-name {
                display: none;
            }
            .lastsales-purchased {
                animation: showHideContentApp 10s;
                animation-iteration-count: infinite;
                .lastsales-purchased-icon {
                    font-size: 11px;
                }
            }
        }
        .app-bottom {
            top: unset;
            bottom: 12px;
        }

        .app-top {
            top: 12px;
            bottom: unset;
        }
    }
    .ls_style_3 {
        .lastsales {
            font-size: 12px;
            .lastsales-close-div {
                .lastsales-close {
                    top: -36px;
                    right: -36px;
                    margin: 30px;
                    box-shadow: none;
                    font-size: 60px;
                    width: 25px;
                    height: 25px;
                    color: #9e9e9e;
                }
            }
            .lastsales-product-name {
                span {
                    width: 215px;
                }
            }
        }
    }
}

@media screen and (min-width: 575px) {
    .ls_style_1 {
        .app-lastsales__1 {
            display: none;
        }
    }
    .ls_style_2,.ls_style_3 {
        .lastsales {
            width: 304px;
            position: fixed;
            bottom: 16px;
            animation: showHideContainerStyle2 10s;
            animation-iteration-count: infinite;
            box-shadow: 0px 1px 5px 0px #dde0e3 !important;
            .lastsales-close {
                display: none;
                top: -25px;
                right: -25px;
                font-size: 52px;
                box-shadow: 0px 1px 10px #dde0e3;
                width: 20px;
                height: 20px;
                background: #fff;
                border-radius: 50vh;
                // animation: showHideContent 10s !important;
                // animation-iteration-count: infinite;
            }
            &:hover {
                box-shadow: 0px 2px 12px 0px #dde0e3 !important;
                .lastsales-close {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            .lastsales-img {
                animation: showHideContent 10s;
                animation-iteration-count: infinite;
            }
            .lastsales-product-name {
                animation: showHideContent 10s;
                animation-iteration-count: infinite;
            }
            .lastsales-customer-name {
                display: none;
            }
            .lastsales-purchased {
                animation: showHideContent 10s;
                animation-iteration-count: infinite;
                font-size: 12px;
                .lastsales-purchased-icon {
                    font-size: 11px;
                }
            }
        }

        // .app-bottom {
        //     top: unset;
        //     bottom: 12px;
        // }
    }
}

@keyframes showHideContainerStyle1 {
    0% {
        left: -400px;
        background-color: rgba(0, 0, 0, 0);
    }
    10% {
        left: 10px;
        background-color: rgba(0, 0, 0, 0.7);
    }
    20% {
        left: 10px;
        background-color: rgba(0, 0, 0, 0.7);
    }
    80% {
        left: 10px;
        background-color: rgba(0, 0, 0, 0.7);
    }
    85% {
        left: -400px;
        background-color: rgba(0, 0, 0, 0);
    }
    100% {
        left: -400px;
        background-color: rgba(0, 0, 0, 0);
    }
}

@keyframes showHideContainerAppStyle1 {
    0% {
        background-color: rgba(0, 0, 0, 0);
    }
    10% {
        background-color: rgba(0, 0, 0, 0.7);
    }
    40% {
        background-color: rgba(0, 0, 0, 0.7);
    }
    45% {
        background-color: rgba(0, 0, 0, 0);
    }
    100% {
        background-color: rgba(0, 0, 0, 0);
    }
}

@keyframes showHideContainerStyle2 {
    0% {
        left: -400px;
        background-color: rgba(255, 255, 255, 0);
        box-shadow: none;
    }
    10% {
        left: 10px;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 12px 0px #dde0e3;
    }
    20% {
        left: 10px;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 12px 0px #dde0e3;
    }
    80% {
        left: 10px;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 12px 0px #dde0e3;
    }
    85% {
        left: -400px;
        background-color: rgba(255, 255, 255, 0);
        box-shadow: none;
    }
    100% {
        left: -400px;
        background-color: rgba(255, 255, 255, 0);
        box-shadow: none;
    }
}

@keyframes showHideContainerAppStyle2 {
    0% {
        background-color: rgba(0, 0, 0, 0);
        box-shadow: none;
        opacity: 0;
        position: fixed;
        left: -1000px;
    }
    10% {
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 12px 0px #dde0e3;
        opacity: 1;
        position: unset;
        left: unset;
    }
    40% {
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 12px 0px #dde0e3;
        opacity: 1;
        position: unset;
        left: unset;
    }
    45% {
        background-color: rgba(0, 0, 0, 0);
        box-shadow: none;
        opacity: 0;
        position: fixed;
        left: -1000px;
    }
    100% {
        background-color: rgba(0, 0, 0, 0);
        box-shadow: none;
        opacity: 0;
        position: fixed;
        left: -1000px;
    }
}

@keyframes showHideContent {
    0% {
        opacity: 0;
        visibility: hidden;
    }
    10% {
        opacity: 1;
        visibility: visible;
    }
    80% {
        opacity: 1;
        visibility: visible;
    }
    83% {
        opacity: 0;
        visibility: hidden;
    }
    100% {
        opacity: 0;
        visibility: hidden;
    }
}

@keyframes showHideContentApp {
    0% {
        opacity: 0;
        visibility: hidden;
    }
    10% {
        opacity: 1;
        visibility: visible;
    }
    40% {
        opacity: 1;
        visibility: visible;
    }
    43% {
        opacity: 0;
        visibility: hidden;
    }
    100% {
        opacity: 0;
        visibility: hidden;
    }
}
</style>
